var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRePageinate = function SvgRePageinate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "rePageinate_svg__mask0_8_4262",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 14,
    height: 14,
    transform: "rotate(-90 0 14)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#rePageinate_svg__mask0_8_4262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.625 12.25V10.4082C2.625 9.76389 3.14733 9.24156 3.79167 9.24156H10.2083C10.8527 9.24156 11.375 9.76389 11.375 10.4082V12.25",
    stroke: "#39404D",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 1.75V3.59178C2.625 4.23611 3.14733 4.75844 3.79167 4.75844H10.2083C10.8527 4.75844 11.375 4.23611 11.375 3.59178V1.75",
    stroke: "#39404D",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71387 7L4.14967 7",
    stroke: "#39404D",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31055 7L7.74635 7",
    stroke: "#39404D",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1416 7L11.5774 7",
    stroke: "#39404D",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  }))));
};
export default SvgRePageinate;